import { FormPropertyType, GlazedSurface, ProjectPropertyKeyType, ProjectPropertyType } from '@/helper/Types'
import { ProcessFunctions } from '@/helper/ProcessFunctions'
import { BuildingHull } from '@/models/BuildingHull.ts'

export abstract class AbstractCalculatedLoad {

  public constructionYear: string | undefined
  public buildingHull?: BuildingHull
  public postalCode: string | undefined
  public altitude: number | undefined

  protected constructor(props: ProjectPropertyType, formData: Partial<FormPropertyType>) {
    this.postalCode = props.projectPostalCode.val
    this.altitude = props.projectAltitude.val
    this.constructionYear = this.getPropsRevertValue(props, formData, 'constructionYear') as string | undefined

    const stories = (this.getPropsRevertValue(props, formData, 'buildingHull') as BuildingHull | undefined)?.stories

    if (stories && stories?.length > 0) {
      this.buildingHull = new BuildingHull(stories)
    }
  }

  protected getPropsRevertValue(
    props: ProjectPropertyType,
    formData: Partial<FormPropertyType>,
    propKey: ProjectPropertyKeyType
  ): number | string | GlazedSurface[] | undefined {
    return ProcessFunctions.getRevertFunction(props[propKey].formRevertType)(formData[propKey] || false) as
      | string
      | number
      | GlazedSurface[]
      | undefined
  }

  validate() {
    if (!this.buildingHull?.stories) {
      return false
    }

    const buildingStories = this.buildingHull.stories
    const topStory = buildingStories.find(s => s.topStory)
    const bottomStory = buildingStories.find(s => s.bottomStory)

    if (!topStory || !bottomStory) {
      return false
    }

    if (buildingStories.length === 1 && topStory !== bottomStory) {
      return false
    }

    if (buildingStories.length > 1 && topStory === bottomStory) {
      return false
    }

    const buildingHullIsValid = buildingStories.every(story => {
      return (story.livingSpace || story.length && story.width) && story.ceilingHeight
    })

    if (!buildingHullIsValid) {
      return false
    }

    return !!this.constructionYear
  }
}
